// Scroll-reveal primitive, mirrored from apps/marketing/src/motion.ts (#265):
// content is fully visible without JS; on mount — and only when the user
// allows motion — <html> gains `has-reveal`, which hides `.reveal` targets
// (styles.css) until they intersect the viewport and gain `.in`. Applied to
// the docs' pure-reading sections; interactive surfaces stay instant.

import { onCleanup, onMount } from "solid-js";

/** How much of a target must be visible before it reveals. */
const REVEAL_THRESHOLD = 0.12;

export function useScrollReveal(): void {
  onMount(() => {
    if (typeof IntersectionObserver === "undefined") return;
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    const targets = document.querySelectorAll(".reveal");
    if (targets.length === 0) return;
    document.documentElement.classList.add("has-reveal");
    const observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (entry.isIntersecting) {
            entry.target.classList.add("in");
            observer.unobserve(entry.target);
          }
        }
      },
      { threshold: REVEAL_THRESHOLD },
    );
    for (const target of targets) observer.observe(target);
    onCleanup(() => {
      observer.disconnect();
      document.documentElement.classList.remove("has-reveal");
    });
  });
}
